import React from 'react';
import { LineChart } from 'lucide-react';
import { BoxProps } from '@mantine/core';
import { IconWrapper } from './IconWrapper';

interface LineChartIconProps extends BoxProps {
    size?: number;
    color?: string;
}

export const LineChartIcon: React.FC<LineChartIconProps> = ({ size = 32, color, ...props }) => {
    return (
        <IconWrapper size={size} {...props}>
            <LineChart size={size} color={color} />
        </IconWrapper>
    );
};
